import React from 'react'
import { Provider as StoreProvider } from 'react-redux'
import { Route } from 'react-router'
import { ConnectedRouter } from 'connected-react-router'
import history from 'hashHistory'
import AppWrapper from './AppWrapper'
import Main from './Main'
import RedirectTo from './RedirectTo'
import ScreenSizeProvider from './ScreenSize'
import ThemeLoader from './ThemeLoader'
import ThemeProviderHolder from './ThemeProviderHolder'
import 'style/_layout.css'

const App = ({ store }) => (
  <StoreProvider store={store}>
    <ScreenSizeProvider />
    <ThemeProviderHolder>
      <ConnectedRouter history={history}>
        <ThemeLoader>
          <AppWrapper>
            <RedirectTo />
            <Route component={Main} />
          </AppWrapper>
        </ThemeLoader>
      </ConnectedRouter>
    </ThemeProviderHolder>
  </StoreProvider>
)

export default App
